import React from 'react'
import { services } from '../../constants/serviceData'

const Service = () => {
    return (
        <section className="bg-[#1e293b] text-white py-16 px-6 flex flex-col items-center">
            <div className="max-w-5xl mx-auto text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-bold mb-4">Servicios</h2>
                <p className="text-white/80 text-lg">
                    Ofrecemos soluciones tecnológicas completas para conectividad, seguridad y soporte técnico
                </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
                {services.map((service, index) => (
                    <div
                        key={index}
                        className="bg-slate-800/50 border border-purple-600/80 hover:border-purple-600/50 rounded-xl transition-all duration-300 hover:scale-105 group p-6 text-center"
                    >
                        <div className="mb-4 flex justify-center">
                            <div className="p-3 bg-purple-700/60 rounded-full group-hover:bg-purple-600/30 transition-colors">
                                <div className="h-8 w-8 text-purple-200" > {service.icon}            </div>
                            </div>
                        </div>
                        <h3 className="text-xl font-semibold mb-3">{service.title}</h3>

                    </div>
                ))}
            </div>
        </section>
    )
}
export default Service